import { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Store/Hooks";
import { selectOrderLeads, selectIsPlaceOrderInProgress, selectIsPlaceOrderComplete } from "../../../Store/Order/selectors";
import { orderActions } from "../../../Store/Order/reducer";
import PatientLeadsOrderListTable from "./Tables/PatientOrderListTable";
import { CreateOrderModel, PatientInfo } from "../../../Services/Models/Order/OrderModel";
import { getCurrentUser } from "aws-amplify/auth";
import Loader from "../../../Components/Helpers/Loaders/Loader";
import SkeletonLoading from "../../../Components/Skeleton/SkeletonLoading";

const OrderKiddo = () => {
  const searchRef = useRef<any>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const patientLeadsList = useAppSelector(selectOrderLeads);
  const isPlaceOrderInProgress = useAppSelector(selectIsPlaceOrderInProgress);
  const isPlaceOrderComplete = useAppSelector(selectIsPlaceOrderComplete);
  // const isPlaceOrderSuccess = useAppSelector(selectIsPlaceOrderSuccess);
  // const isPlaceOrderFailed = useAppSelector(selectIsPlaceOrderFailed);
  const dispatch = useAppDispatch();
  const [filtered, setFiltered] = useState<PatientInfo[]>([]);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    if (patientLeadsList.length > 0) {
      setFiltered(patientLeadsList);
      setTotal(patientLeadsList?.length);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } else {
      setIsLoading(false);
      setFiltered([]);
      setTotal(0);
    }
  }, [patientLeadsList]);

  const onSearch = (text: string) => {
    let toSearch: PatientInfo[] = patientLeadsList;
    if (text) {
      setSearch(text);
      let newFiltered: PatientInfo[] = patientLeadsList.filter((el: PatientInfo) => el.firstname.toLowerCase().includes(text.toLowerCase()) || el.ecFirstName.toLowerCase().includes(text.toLowerCase()) || el.ecLastName.toLowerCase().includes(text.toLowerCase()));
      setFiltered(newFiltered);
    } else {
      setSearch(undefined);
      setFiltered(toSearch);
    }
  };
    

  const onOrderSubmit = async () => {
    try {
      if (patientLeadsList.length > 0) {
        let currentProvider = await getCurrentUser();
        const toOrder: CreateOrderModel = {
          provider_id: currentProvider.username,
          provider_org_id: currentProvider.username,
          patients: patientLeadsList
        };
        dispatch(orderActions.placeOrderStart(toOrder));
      }
    } catch (error) {
      console.log("Error order submit :", error)
    }
  };

  useEffect(() => {
    // if (isPlaceOrderComplete && isPlaceOrderSuccess) {
    //   navigate("/order-complete");
    // }
    // if (isPlaceOrderComplete && isPlaceOrderFailed) {
    //   dispatch(orderActions.resetOrderProcessingStates());
    // }
    if (isPlaceOrderComplete) {
      navigate("/order-complete");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaceOrderComplete]);

  const onAddPatientClick = () => {
    navigate("/addpatientleads")
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="page-inner with-sidebar">
          <div className="order-page">
            <div className="order-wrapper">
              <div className="order-header-col mb-4">
                <h2 className="heading-main">Order Kiddo bands</h2>
                <p className="mb-0">
                  You can order a Kiddo band for each patient to remotely
                  monitor their health. <br /> Once activated by the patient's
                  parent or caregiver, their health data will be available in
                  regular reports.
                </p>
              </div>
              <div className="order-inner">
                {patientLeadsList?.length > 0 ? (
                  <>
                    <div className="d-flex justify-content-between order-filter-row mb-4">
                      <div className="d-flex align-items-center">
                        <div className="img-label d-none">
                          <SVG
                            src="Assets/Images/Icons/OrderKiddo.svg"
                            className="fill-success"
                            width="24"
                            height="24"
                          />
                        </div>
                        <div className="order-label fs-20 ms-2 d-none">
                          Order by selecting patients:
                        </div>
                      </div>

                      {/* order filter row start */}
                      <div className="d-flex w-50 justify-content-end">
                        <div className="form-group w-auto d-flex flex-column mb-0 align-items-end ms-3">
                          <div className="d-flex  search-field max-w-237">
                            <div className="d-flex flex-grow-2 w-100 position-relative">
                              <label htmlFor="" className="label search-icon">
                                <img
                                  src="Assets/Images/Icons/search-dark.svg"
                                  alt="search"
                                  width="16"
                                  height="16"
                                />
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search for patients"
                                value={search}
                                onChange={(e) => onSearch(e.target.value)}
                                ref={searchRef}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* order filter row end */}
                    </div>
                    <PatientLeadsOrderListTable
                      loading={isLoading}
                      tableData={filtered}
                      dataLength={filtered.length}
                      rowsPerPage={10}
                    />
                  </>
                ) : (
                  <>
                    <div className="text-center gbox-shadow pt-4 pb-4 mx-auto bg-white">
                      <p>Please import patient(s) to place an order.</p>
                      <button type="button" className="btn btn-success order-btn w-auto" onClick={onAddPatientClick}>
                        Add Patient
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="order-sidebar d-flex justify-content-between flex-column">
            <div className="sidebar-top">
              <div className="mb-32 text-center  side-heading">Order List</div>
              <div className="fs-20 mb-3">Product :</div>
              <div className="d-flex product-detail">
                <div className="img-wrap">
                  <img
                    src="Assets/Images/Icons/KiddoBand.png"
                    alt="Kiddo-Band"
                    width="102"
                    height="136"
                  />
                </div>
                <div className="product-info-col">
                  <div className="product-name text-success fs-22">
                    Kiddo band
                  </div>
                  <div className="product-by mb-4">by Kiddo Health Inc.</div>
                  {/* <div className="qty mb-2">Qty. </div>
                            <div className="form-group">
                                <div className="price-controller d-flex align-items-center">
                                <button className="control-handle minus btn">-</button>
                                <input
                                    type="number"
                                    className="form-control"
                                    onChange={(e) => setcount(e.currentTarget.value)}
                                    value={count}
                                />
                                <button className="control-handle plus btn">+</button>
                                </div>
                            </div> */}
                </div>
              </div>
              <div className="product-info pt-3">
                <div className="flex-between mb-3 ">
                  <div className="fs-22 font-500">Total: </div>
                  <div className="fs-22 font-500">
                    {isLoading ? (
                      <SkeletonLoading width={75} height={33} />
                    ) : (
                      <>
                        {total} Qty.
                      </>
                    )}
                  </div>
                </div>
                {/* <p className="text-color-6b">
                  You will receive a confirmation email soon. Shipping will
                  commence once the addressee confirms the order and shipping
                  details via email.
                </p> */}
              </div>
            </div>
            <div className="sidebar-bottom">
              {isLoading ? (
                <SkeletonLoading width={392} height={90} />
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success flex-between px-4 fs-28 py-4"
                    disabled={!patientLeadsList?.length}
                    onClick={() => onOrderSubmit()}
                  >
                    <span> Order Kiddo Bands </span>
                    <span>
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
          {/* Sidebar for  portrait view  */}

          <div className="order-sidebar-portrait">
            <div className="d-flex">
              <div className="card w-100">
                <div className="label fs-20 mb-3">Product :</div>
                <div className="d-flex">
                  <div className="img-wrap">
                    <img
                      src="Assets/Images/Icons/KiddoBand.png"
                      alt="Kiddo-Band"
                      width="102"
                      height="136"
                    />
                  </div>
                  <div className="product-info-col d-flex flex-column justify-content-between w-100">
                    <div className="infotop">
                      <div className="product-name text-success fs-22">
                        Kiddo band
                      </div>
                      <div className="product-by mb-4">
                        by Kiddo Health Inc.
                      </div>
                    </div>
                    <div className="d-flex  justify-content-between">
                      <div className="fs-22 font-500">Total: </div>
                      <div className="fs-22 font-500">
                        {isLoading ? (
                          <SkeletonLoading width={75} height={33} />
                        ) : (
                          <>
                            {total} Qty.
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-info d-flex flex-column justify-content-between">
                <p className="text-color-6b">
                  {/* Your will receive a confirmation email soon. Shipping will
                  commence once the addressee confirms the order and shipping
                  details via email. */}
                </p>
                {isLoading ? (
                  <SkeletonLoading width={392} height={90} />
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-success flex-between px-4 h-50 align-items-center"
                      disabled={!patientLeadsList?.length}
                      onClick={() => onOrderSubmit()}
                    >
                      <span> Order Kiddo Bands </span>
                      <span>
                        <i className="fa-solid fa-angle-right"></i>
                      </span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          {/* Sidebar for portrait view end */}
        </div>
      </div>
      {isPlaceOrderInProgress && <Loader />}

    </>
  );
};

export default OrderKiddo;
